import type { WhatsAppSystemStatusLevel } from '@/services/whatsappSystemStatusService';

/**
 * The text on one status-bar chip.
 *
 * By default a chip reads "<name> <level>" ("WhatsApp healthy", "Fora degraded"). A blanket "degraded" hides which
 * part is broken: on 9 October 2026 "Fora degraded" meant only that the monitoring quote test had failed since
 * 9 August, while sign-in and the booking sync were fine. When the status RPC names the broken part (summary_label,
 * e.g. "bookings OK · quote test failing") the chip says that instead. The colour still follows the level, so a real
 * fault stays amber; a healthy component never shows a summary.
 */
/**
 * The word on a chip. A source that has stopped being read is "behind" everywhere: on the Today screen's strip it already says "behind", and the top bar used to say "stale" for the
 * same state, so the same source read two ways. The state itself (the level, the colour, the severity) is unchanged; only the word is.
 */
const CHIP_WORD: Partial<Record<WhatsAppSystemStatusLevel, string>> = { stale: 'behind' };

export function componentChipLabel(
  name: string,
  level: WhatsAppSystemStatusLevel,
  summaryLabel?: string | null,
): string {
  const summary = typeof summaryLabel === 'string' ? summaryLabel.trim() : '';
  if (summary && level !== 'healthy' && level !== 'unknown') return `${name}: ${summary}`;
  return `${name} ${CHIP_WORD[level] ?? level}`;
}
